import React from 'react';
import { useParams } from 'react-router-dom';
import Navigation from '../components/Navigation';
import './Deposition.css';
import DirectoryTreeView from '../components/DirectoryTreeComponent';

const Deposition = () => {
  const { type } = useParams();

  return (
    <div 
    style={{
        position:"fixed",
        top:0,
        width:"100%"
      }}

    >
      <div className="depositionContent">
      <Navigation></Navigation>
      <DirectoryTreeView type='{type}'/>
      </div>
    </div>
  );
};

export default Deposition;
